// Las tarjetas del inicio que el dueño dejó visibles en el portal de Zoco (`negocio.tarjetasVisibles`,
// que llega en el canje). Deciden qué secciones del menú del panel se muestran en ese negocio: un
// restaurante que solo usa Mesas no tiene por qué ver Eventos ni Canchas.
//
// Oculta links del menú y las guardas del panel (organizerAccessGuards) la usan para no dejar entrar
// por URL directa a una sección de una tarjeta apagada. No es un permiso: lo que cada persona puede
// hacer lo siguen diciendo el token y `perms`.

/**
 * Ruta del panel → tarjeta de Zoco que la trae. Las que no están (Asignar roles, Información de
 * pagos) sirven a cualquier negocio y se ven siempre.
 */
const RUTA_A_TARJETA = {
  "/organizer": "tickets-eventos",
  "/organizer/reports": "tickets-eventos",
  "/organizer/events": "tickets-eventos",
  "/organizer/asistencia": "tickets-eventos",
  "/organizer/presencial": "tickets-eventos",
  "/organizer/coupons": "tickets-eventos",
  "/organizer/gifts": "tickets-eventos",
  "/organizer/marketing": "tickets-eventos",
  "/organizer/sponsors": "tickets-eventos",
  "/organizer/reservas": "tickets-mesas",
  "/organizer/canchas": "tickets-canchas",
  "/organizer/canchas/cumpleanos": "tickets-canchas",
  "/organizer/estadisticas/canchas": "tickets-canchas",
  "/organizer/turnos": "tickets-turnos",
  "/organizer/estadisticas/beauty": "tickets-turnos",
  // Las fichas sirven a salón, club y bar: se ven mientras el negocio use alguno de los tres.
  "/organizer/clientes": ["tickets-turnos", "tickets-canchas", "tickets-mesas"],
};

/**
 * Si el negocio muestra `ruta` en el menú. Sin `tarjetasVisibles` (un login propio de Tickets, una
 * sesión anterior al campo o un Zoco que no lo manda) se muestra todo, igual que antes.
 */
export const negocioMuestraRuta = (negocio, ruta) => {
  const visibles = negocio?.tarjetasVisibles;
  if (!Array.isArray(visibles)) return true;

  const tarjeta = RUTA_A_TARJETA[ruta];
  if (Array.isArray(tarjeta)) return tarjeta.some((t) => visibles.includes(t));
  return !tarjeta || visibles.includes(tarjeta);
};
